// Runtime configuration. Nothing here is secret.
const trimSlash = (s: string) => s.replace(/\/+$/, "");

/** API origin. Empty string means same origin, which is how vd-server serves the ops console. */
export const API_BASE = trimSlash(import.meta.env.VITE_VD_API_BASE ?? "");

/** Dev sign-in is compiled in only for dev servers and mock builds. */
export const DEV_SIGNIN_ENABLED = import.meta.env.DEV || import.meta.env.MODE === "mock";
